module.exports = __webpack_public_path__ + "static/18-356d0535eb1abdd566dd4426cad84f06.jpg";